import { extractImageFrames, clampTo } from '../../tools';
import type { GeneralModelConfig } from '../../general';

export const minimaxConfigs: Record<string, GeneralModelConfig> = {
    'hailuo-h3': {
        // https://qmy27nhsd9.apifox.cn/514679297e0
        apiPath: '/v1/api/generate',
        pollApiPath: '/v1/api/result?id={id}',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, audioUri, audioUris, aspectRatio, duration, quality, modelUi } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage, lastImage] = extractImageFrames(imagePrompt);
            const images = (imagePrompt ?? []).filter(Boolean).slice(0, 9);
            const audios = ((audioUris?.length ?? 0) > 0 ? audioUris! : audioUri ? [audioUri] : []).filter(Boolean).slice(0, 3);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    model: 'minimax-h3',
                    prompt: prompt,
                    aspectRatio: clampTo(['9:16', '3:4'].includes(aspectRatio || '') ? 'portrait' : 'landscape', ['portrait', 'landscape'] as const, 'landscape'),
                    duration: Math.min(
                        clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                        clampTo((quality || '768p').toLowerCase().replace('2k', '1080p'), ['480p', '768p', '1080p'] as const, '768p') === '1080p' ? 10 : 15,
                    ),
                    resolution: clampTo((quality || '768p').toLowerCase().replace('2k', '1080p'), ['480p', '768p', '1080p'] as const, '768p'),
                    // 首帧 URL
                    images: [firstImage!],
                    // system
                    replyType: 'async',
                };
            // 首尾帧模式
            } else if (frameMode === 'first_last') {
                return {
                    model: 'minimax-h3',
                    prompt: prompt,
                    aspectRatio: clampTo(['9:16', '3:4'].includes(aspectRatio || '') ? 'portrait' : 'landscape', ['portrait', 'landscape'] as const, 'landscape'),
                    duration: Math.min(
                        clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                        clampTo((quality || '768p').toLowerCase().replace('2k', '1080p'), ['480p', '768p', '1080p'] as const, '768p') === '1080p' ? 10 : 15,
                    ),
                    resolution: clampTo((quality || '768p').toLowerCase().replace('2k', '1080p'), ['480p', '768p', '1080p'] as const, '768p'),
                    // 首尾帧 URL
                    images: [firstImage!, lastImage!],
                    // system
                    replyType: 'async',
                };
            // 参考模式
            } else if (frameMode === 'ref') {
                return {
                    model: 'minimax-h3',
                    prompt: prompt,
                    aspectRatio: clampTo(['9:16', '3:4'].includes(aspectRatio || '') ? 'portrait' : 'landscape', ['portrait', 'landscape'] as const, 'landscape'),
                    duration: Math.min(
                        clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                        clampTo((quality || '768p').toLowerCase().replace('2k', '1080p'), ['480p', '768p', '1080p'] as const, '768p') === '1080p' ? 10 : 15,
                    ),
                    resolution: clampTo((quality || '768p').toLowerCase().replace('2k', '1080p'), ['480p', '768p', '1080p'] as const, '768p'),
                    // 参考 URL
                    ...(images.length > 0 ? { images } : {}),
                    ...(audios.length > 0 ? { audios } : {}),
                    // system
                    replyType: 'async',
                };
            // 文生视频模式
            } else {
                return {
                    model: 'minimax-h3',
                    prompt: prompt,
                    aspectRatio: clampTo(['9:16', '3:4'].includes(aspectRatio || '') ? 'portrait' : 'landscape', ['portrait', 'landscape'] as const, 'landscape'),
                    duration: Math.min(
                        clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                        clampTo((quality || '768p').toLowerCase().replace('2k', '1080p'), ['480p', '768p', '1080p'] as const, '768p') === '1080p' ? 10 : 15,
                    ),
                    resolution: clampTo((quality || '768p').toLowerCase().replace('2k', '1080p'), ['480p', '768p', '1080p'] as const, '768p'),
                    // system
                    replyType: 'async',
                };
            }
        },
    },
};